import { useMemo } from 'react'
import { CountryCode } from '@carsys/enums/country-code'
import { countryCodeMapping, euCountries } from '@cbgms/base/utils/vehicle/constants'
import { LicensePlateVariant } from '@carsys/ui/src/LicensePlate/enum'

export interface IRegistrationDisplayConfig {
  countryCode?: string
  countryCodeText: string
  isEU: boolean
  isBlueBox: boolean
  isSquare: boolean
  variantClassName: string
}

const variantConfig: { [key in keyof typeof LicensePlateVariant]: IRegistrationDisplayConfig } = {
  BEWhiteRed: { countryCode: 'BE', countryCodeText: 'BE', isEU: true, isBlueBox: true, isSquare: false, variantClassName: '' },
  NLYellow: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: true, isSquare: false, variantClassName: '' },
  NLYellowSquare: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: true, isSquare: true, variantClassName: '' },
  NlYellowMoped: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: true, isSquare: true, variantClassName: '' },
  NLBlueMoped: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: false, isSquare: true, variantClassName: 'variant-blue' },
  NLBlue: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: false, isSquare: false, variantClassName: 'variant-blue' },
  NLBlueSquare: {
    countryCode: 'NL',
    countryCodeText: 'NL',
    isEU: true,
    isBlueBox: false,
    isSquare: true,
    variantClassName: 'variant-blue'
  },
  NLGreen: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: false, isSquare: false, variantClassName: 'variant-green' },
  NLGreenSquare: {
    countryCode: 'NL',
    countryCodeText: 'NL',
    isEU: true,
    isBlueBox: false,
    isSquare: true,
    variantClassName: 'variant-green'
  },
  NLWhite: { countryCode: 'NL', countryCodeText: 'NL', isEU: true, isBlueBox: false, isSquare: false, variantClassName: 'variant-white' },
  NLWhiteSquare: {
    countryCode: 'NL',
    countryCodeText: 'NL',
    isEU: true,
    isBlueBox: false,
    isSquare: true,
    variantClassName: 'variant-white'
  }
}

export const useGetRegistrationDisplayConfig = (
  countryCode: CountryCode | '',
  variant?: LicensePlateVariant
): IRegistrationDisplayConfig => {
  return useMemo(() => {
    if (variant && variantConfig[variant]) {
      return variantConfig[variant]
    }

    return {
      countryCode,
      countryCodeText: patchGbToUK((countryCode && countryCodeMapping[countryCode]) || countryCode),
      isEU: (countryCode && euCountries.includes(countryCode)) || false,
      isBlueBox: true,
      isSquare: false,
      variantClassName: ''
    }
  }, [countryCode, variant])
}

const patchGbToUK = (text?: string) => {
  if (text?.localeCompare && text.localeCompare('GB') === 0) {
    return 'UK' // since brexit, Gb is not shown anymore, instead UK is written.
  }
  return text || ''
}
